import _ from "lodash"
import { SetterOrUpdater, useRecoilState } from "recoil"
import { FormDataState } from "hooks/form-data/FormDataState"

export const useGlobalFormData = <TData = Record<string, any>>(id: string, defaultValue?: TData): [TData, SetterOrUpdater<TData>] => {
    const [formData, setFormData] = useRecoilState(FormDataState(id, defaultValue))
    return [formData as TData, setFormData]
}
